import { useState } from "react";
import { useNavigate } from 'react-router-dom';

export default function UpgradeModal({ isOpen, onClose, reason, cta }: any) {
  const navigate = useNavigate();
  if (!isOpen) return null;

  const contentMap: any = {
  duration_limit: {
    title: "⏱️ Video too long",
    description: "Free plan supports videos up to 60 seconds.",
  },
  quality_limit: {
    title: "🎥 HD quality locked",
    description: "Upgrade to download in HD (720p, 1080p, 4K).",
  },
  daily_limit: {
    title: "🚫 Daily limit reached",
    description: "You’ve used all your free downloads for today.",
  },
  default: {
    title: "🚀 Upgrade to Pro",
    description: "Unlock unlimited downloads and full features.",
  }
};

const content = contentMap[reason] || contentMap.default;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-[400px] text-center">
        <h2 className="text-2xl font-bold mb-2">
          {content.title}
        </h2>

        <p className="text-gray-600 mb-4">
          {content.description}
        </p>
        <p className="text-sm text-red-500 mb-3 font-medium">
          ⚠️ Upgrade now to continue instantly
        </p>

        <ul className="text-left mb-6 space-y-2">
          <li>🚀 Download full videos without limits</li>
          <li>🎬 Unlock HD, 4K & 8K quality</li>
          <li>⚡ Skip daily limits completely</li>
          <li>🔓 Access everything instantly</li>
        </ul>
        <p className="text-lg font-semibold mb-2">
          Only $9.99/month
        </p>

        <p className="text-xs text-gray-400 mb-4">
          Cancel anytime • Instant access
        </p>
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded-lg w-full mb-2"
         onClick={() => navigate('/app/premium')}
        >
          {cta || "🔥 Unlock Unlimited Downloads"}
        </button>

        <button
          className="text-gray-500 text-sm"
          onClick={onClose}
        >
          Maybe later
        </button>
      </div>
    </div>
  );
}